
import { omit } from 'lodash'
import { SHOW_ALERT } from '../actions'

/*
	payload: {
		text: String,
		message: String,
		dismissable: Boolean,
		actions: [{
			text: String,
			handler: function,
			type: String
		}]
	}
*/ 
const state = { 
	dialogs: {}
}

const mutations = {
	[SHOW_ALERT]: (state, payload) => {
		let key = payload.message.substr (0, 30).replace (/\s/gm, '') + payload.message.length
		if (state.dialogs[key] != null) {
			return
		}
		payload.key = key
		state.dialogs = {
			...state.dialogs,
			[key]: payload
		}
		return key
	},

	removeDialog: (state, key) => {
		state.dialogs = omit (state.dialogs, key)
	}
}


export default {
	state,
	mutations
}